/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
// import scriptLoader from 'react-async-script-loader';
import { node } from 'prop-types';
import withAsyncScript from '../../../../lib/scriptLoader';

import { cardIslePluginConfig } from '../../../../state/ducks/Checkout/ducks/Recipient/ducks/CardIsle/CardIsle-Helpers';

const { cardIsleGiftCardsURL } = cardIslePluginConfig;

const LoadCardIsleLib = ({ children }) => <>{children}</>;

LoadCardIsleLib.propTypes = {
    children: node,
};

LoadCardIsleLib.defaultProps = {
    children: null,
};

export default withAsyncScript(cardIsleGiftCardsURL)(LoadCardIsleLib);
